export default __webpack_public_path__ + "static/media/managw.4fb631a3.svg";